export const DASHBOARD_REFRESH_EVENT = 'dashboard:refresh'
